import React from 'react';
import IconBase from './IconBase';

const WorksheetIcon = props => {
    return (
        <IconBase {...props} viewBox="0 0 128 128">
            <use xlinkHref="#page" className="icon-red icons-svg"></use>
            <g>
                <rect x="44" y="82" fill="#FFFFFF" width="20" height="4" />
                <rect x="44" y="72" fill="#FFFFFF" width="40" height="4" />
                <rect x="44" y="62" fill="#FFFFFF" width="40" height="4" />
                <rect x="44" y="52" fill="#FFFFFF" width="40" height="4" />
            </g>
            <use xlinkHref="#page-finish" className="icon-red icons-svg"></use>
        </IconBase>
    )
}

export default WorksheetIcon;